import { useState } from 'react';
import { LayoutModule } from '../../../layout/modules';
import { ProcedureParamsFilters } from './filters';
import { ProcedureParamsList } from './list';
import { ProcedureParams as Procedure } from '../../../../shared/types/systemConfiguration/procedureParams';
import { PROCEDURE_NEW } from '../../../../routes/paths';
import { isTrainerOrQuality } from '../../../../shared/types/profiles';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';

export const ProcedureParams = () => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const [filters, setFilters] = useState<Procedure>();

    return (
        <>
            <LayoutModule
                title="Búsqueda de Trámite PQR"
                showTitle
                {...(!isTrainerOrQuality(type) && {
                    createPath: PROCEDURE_NEW,
                })}
            >
                <ProcedureParamsFilters
                    onFilter={(filters) => setFilters(filters)}
                />
            </LayoutModule>
            <ProcedureParamsList filters={filters} />
        </>
    );
};
